/**
 * useTrackPageView — invocă pixel-ul de tracking la fiecare schimbare de rută.
 *
 * Foloseşte un <img> hidden care descarcă /api/track/pixel.gif — endpoint public,
 * fire-and-forget (nu blochează UI-ul). Pentru fiecare navigare React Router
 * trimite: page (pathname), ref (document.referrer în prima cerere).
 *
 * Uz:
 *   Se include o singură dată în AppShell / MainLayout.
 *   useTrackPageView();
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API_BASE } from "@/lib/api";
import { isAnalyticsEnabled } from "@/components/CookieBanner";

export function useTrackPageView() {
  const location = useLocation();
  const firstRef = useRef(true);

  useEffect(() => {
    if (!isAnalyticsEnabled()) return; // iter96 · respect cookie consent
    const page = location.pathname + (location.search || "");
    const ref = firstRef.current ? (document.referrer || "") : "";
    firstRef.current = false;

    // Fire-and-forget: fetch as Image object (bypasses fetch CORS / promises)
    const params = new URLSearchParams({ event: "pageview", page });
    if (ref) params.set("ref", ref);
    const img = new Image();
    img.src = `${API_BASE}/track/pixel.gif?${params.toString()}&t=${Date.now()}`;
    // No cleanup needed — the Image is GC'd once out of scope
  }, [location.pathname, location.search]);
}

export default useTrackPageView;
